import { useEffect, useState } from "react";

export interface UseCurrentPageEditSessionArgs {
    isInActiveEditSession: boolean;
    isInEditMode: boolean;
    onSessionEnd: () => void;
}

const useCurrentPageEditSession = ({
    isInActiveEditSession,
    isInEditMode,
    onSessionEnd,
}: UseCurrentPageEditSessionArgs) => {
    const [isExpiredSession, setIsExpiredSession] = useState(false);
    const [hasBegunEditSession, setHasBegunEditSession] = useState(false);
    const [hasFiredOnSessionEnd, setHasFiredOnSessionEnd] = useState(false);

    useEffect(() => {
        if (isInActiveEditSession) {
            setHasBegunEditSession(true);
            setHasFiredOnSessionEnd(false);
            setIsExpiredSession(false);
        }
    }, [isInActiveEditSession]);

    useEffect(() => {
        if (
            hasBegunEditSession &&
            !isInActiveEditSession &&
            !isExpiredSession
        ) {
            setIsExpiredSession(true);
            if (!hasFiredOnSessionEnd) {
                onSessionEnd();
                setHasFiredOnSessionEnd(true);
            }
        }
    }, [
        hasBegunEditSession,
        hasFiredOnSessionEnd,
        isInActiveEditSession,
        isExpiredSession,
        onSessionEnd,
    ]);

    useEffect(() => {
        if (!isInEditMode) {
            setHasBegunEditSession(false);
            setHasFiredOnSessionEnd(false);
            setIsExpiredSession(false);
        }
    }, [isInEditMode]);
};

export default useCurrentPageEditSession;
